// bathroomMaterials.js
import { PBRMaterial, Texture } from '@babylonjs/core';

const BASE_URL = 'https://yuxbcsdfnhttlrmzsqvz.supabase.co/storage/v1/object/public/textures';

export function createWhiteCeramicMaterial(scene) {
  const mat = new PBRMaterial('whiteCeramicPBR', scene);
  mat.albedoTexture = new Texture(`${BASE_URL}/TilesMosaicYubi003_COL_8K.png`, scene);
  mat.bumpTexture = new Texture(`${BASE_URL}/TilesMosaicYubi003_NRM_8K.png`, scene);
  mat.reflectivityTexture = new Texture(`${BASE_URL}/TilesMosaicYubi003_REFL_8K.png`, scene);
  mat.specularGlossinessTexture = new Texture(`${BASE_URL}/TilesMosaicYubi003_GLOSS_8K.png`, scene);
  mat.ambientTexture = new Texture(`${BASE_URL}/TilesMosaicYubi003_AO_8K.png`, scene);

  mat.useSpecularOverAlpha = true;
  mat.useAlphaFromAlbedoTexture = false;
  mat.roughness = 0.1;
  mat.metallic = 0.0;
  mat.useParallaxOcclusion = true;
  mat.parallaxScaleBias = 1;
  return mat;
}

export function createWhiteDoorMaterial(scene) {
  const mat = new PBRMaterial('whiteDoorMaterial', scene);
  mat.albedoTexture = new Texture(`${BASE_URL}/WoodPaintedWhite002_COL_2K.jpg`, scene);
  mat.bumpTexture = new Texture(`${BASE_URL}/WoodPaintedWhite002_NRM_2K.png`, scene);
  mat.microSurfaceTexture = new Texture(`${BASE_URL}/WoodPaintedWhite002_GLOSS_2K.jpg`, scene);
  mat.reflectivityTexture = new Texture(`${BASE_URL}/WoodPaintedWhite002_REFL_2K.jpg`, scene);

  mat.metallic = 0.0;
  mat.roughness = 0.3;
  mat.environmentIntensity = 1.0;
  return mat;
}

export function createGreyQuartzStoneTileMaterial(scene) {
  const mat = new PBRMaterial('beigeTavertineTileMaterial', scene);

  mat.albedoTexture = new Texture(`${BASE_URL}/Poliigon_StoneQuartziteTile_8608_BaseColor.jpg`, scene);
  mat.bumpTexture = new Texture(`${BASE_URL}/Poliigon_StoneQuartziteTile_8608_Normal.png`, scene);
  mat.metallicTexture = new Texture(`${BASE_URL}/Poliigon_StoneQuartziteTile_8608_Metallic.jpg`, scene);
  mat.roughnessTexture = new Texture(`${BASE_URL}/Poliigon_StoneQuartziteTile_8608_Roughness.jpg`, scene);
  mat.ambientTexture = new Texture(`${BASE_URL}/Poliigon_StoneQuartziteTile_8608_AmbientOcclusion.png`, scene);
  mat.displacementTexture = new Texture(`${BASE_URL}/Poliigon_StoneQuartziteTile_8608_Displacement.tiff`, scene);

  // If you want larger tiles (fewer repeats), use values < 1
  const tileScale = 0.2;
  mat.albedoTexture.uScale = tileScale;
  mat.albedoTexture.vScale = tileScale;
  mat.bumpTexture.uScale = tileScale;
  mat.bumpTexture.vScale = tileScale;
  mat.metallicTexture.uScale = tileScale;
  mat.metallicTexture.vScale = tileScale;
  mat.roughnessTexture.uScale = tileScale;
  mat.roughnessTexture.vScale = tileScale;
  mat.ambientTexture.uScale = tileScale;
  mat.ambientTexture.vScale = tileScale;
  mat.displacementTexture.uScale = tileScale;
  mat.displacementTexture.vScale = tileScale;

  mat.useSpecularOverAlpha = true;
  mat.useAlphaFromAlbedoTexture = false;
  mat.metallic = 0.0;
  mat.roughness = 0.2;
  mat.useParallaxOcclusion = true;
  mat.parallaxScaleBias = 1;
  mat.environmentIntensity = 1.0;

  return mat;
}

export function createBlackCeramicHexagonMaterial(scene) {
  const mat = new PBRMaterial("TilesCeramicHexagon001", scene);

  mat.albedoTexture = new Texture(`${BASE_URL}/TilesCeramicHexagon001_COL_8K.jpg`, scene);
  mat.ambientTexture = new Texture(`${BASE_URL}/TilesCeramicHexagon001_AO_8K.jpg`, scene);
  mat.bumpTexture = new Texture(`${BASE_URL}/TilesCeramicHexagon001_NRM_8K.jpg`, scene);
  mat.displacementTexture = new Texture(`${BASE_URL}/TilesCeramicHexagon001_DISP16_8K.tif`, scene);
  mat.reflectivityTexture = new Texture(`${BASE_URL}/TilesCeramicHexagon001_REFL_8K.jpg`, scene);
  mat.microSurfaceTexture = new Texture(`${BASE_URL}/TilesCeramicHexagon001_GLOSS_8K.jpg`, scene);
  mat.invertRoughness = true; // Because it's a GLOSS map

  mat.metallic = 0.0;
  mat.useParallaxOcclusion = true;
  mat.parallaxScaleBias = 0.03;
  mat.environmentIntensity = 1.0;
  mat.useSpecularOverAlpha = true;
  mat.useAlphaFromAlbedoTexture = false;

  return mat;
}
